import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "../../axiosClient/userApi";
import { zodParseWithLog } from "../../apiErrorLogs";
import { z } from "zod";
interface ApiTagTypeFromAPI {
    "@id": string;
    "@type": "TagType";
    id: string;
    name: string;
    multiple: boolean;
    required: boolean;
    canView: boolean;
    canModify: boolean;
    canDelete: boolean;
}
interface ApiTagValueFromAPI {
    "@context": string;
    "@id": string;
    "@type": "TagValue";
    id: string;
    tagType: ApiTagTypeFromAPI;
    name: string;
    slug: string;
    description: string;
    color: string;
    sortOrder: number;
    createdAt: string;
    updatedAt: string;
    canView: boolean;
    canModify: boolean;
    canDelete: boolean;
}

const ApiTagTypeFromAPISchema: z.ZodSchema<ApiTagTypeFromAPI> = z.object({
    "@id": z.string(),
    "@type": z.literal("TagType"),
    id: z.string(),
    name: z.string(),
    multiple: z.boolean(),
    required: z.boolean(),
    canView: z.boolean(),
    canModify: z.boolean(),
    canDelete: z.boolean(),
});

const ApiTagValueFromAPISchema: z.ZodSchema<ApiTagValueFromAPI> = z.object({
    "@context": z.string(),
    "@id": z.string(),
    "@type": z.literal("TagValue"),
    id: z.string(),
    tagType: ApiTagTypeFromAPISchema,
    name: z.string(),
    slug: z.string(),
    description: z.string(),
    color: z.string(),
    sortOrder: z.number(),
    createdAt: z.string(),
    updatedAt: z.string(),
    canView: z.boolean(),
    canModify: z.boolean(),
    canDelete: z.boolean(),
});

export const useUpdateTagValue = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({
            tagValueId,
            tagValue,
        }: {
            tagValueId: string;
            tagValue: any;
        }): Promise<ApiTagValueFromAPI> => {
            const response = await loggedInApiCall.patch(`/api/tag_values/${tagValueId}`, tagValue, {
                headers: {
                    "Content-Type": "application/merge-patch+json",
                },
            });

            return zodParseWithLog(response.data, ApiTagValueFromAPISchema, "updateTagValue");
        },
        onSuccess: (updatedTagValue) => {
            // Invalider les caches liés aux tag values
            queryClient.invalidateQueries(["tagValues"]);
            queryClient.invalidateQueries(["tagValue", updatedTagValue.id]);
        },
    });
};
